import React from 'react'

const Jva_sort = () => {
    return (
        <div className='container'>
            <div class="entry-content clear" itemprop="text">


      
      
<p>Learn sorting of stack in Java. Java example to
      sort elements in stack. I have used built-in Stack from java.util.Stack. Sorting of Integer value of
      java.util.Stack.<br/>
     
</p>
<h2>1. Overview of sorting of Stack in Java</h2>
<p>Well, when I heard the first time about sorting of the stack, I thought why we required to sort of any stack.
      Initially, I thought, this is rubbish and time passing thing, but later point in time, realize, this can be
      an interview question. In fact, most of the interviewer asks this question, how to sort stack in Java or
      your preferred language. I have written a Java program or example for sorting a Stack in Java.</p>
<h2>2. Java Program for Sorting Stack</h2>
<p>In this program I have taken in built Stack from java.util.stack package, you can take this your own stack
      class to sort the input, this completely your choice.</p>
<div class="containers ">
      
      <div class="enlighter" >
            <div class="">
                  <div><span class="keywords">package</span><span class="library">
                              com.mysoftkey.ds.stack</span><span class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span><span class="keywords">import</span><span
                              class="library"> java.util.Iterator</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span><span class="keywords">import</span><span
                              class="library"> java.util.Stack</span><span class="plain">;</span>
                  </div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span><span class="comment">/**</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * Demonstration of Java program to sort stack </span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * in ascending order.</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * </span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * @author ranjeet jha</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> *</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> */</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span><span class="keywords">public</span><span
                              class="plain"> </span><span class="keywords">class</span><span
                              class="plain"> SortingStackExample </span><span
                              class="enlighter-g1">&#123;</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">public</span><span
                              class="plain"> </span><span class="keywords">static</span><span
                              class="plain"> </span><span class="enlighter-k5">void</span><span
                              class="plain"> </span><span class="enlighter-m0">main</span><span
                              class="enlighter-g1">(</span><span class="enlighter-k5">String</span><span
                              class="enlighter-g1">[]</span><span class="plain"> args</span><span
                              class="enlighter-g1">)</span><span class="plain"> </span><span
                              class="enlighter-g1">&#123;</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment"> // create new stack and
                              add elements into it</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> stack = </span><span class="enlighter-k3">new</span><span
                              class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;()</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span
                              class="enlighter-m3">addElement</span><span class="enlighter-g1">(</span><span
                              class="enlighter-n1">9</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span
                              class="enlighter-m3">addElement</span><span class="enlighter-g1">(</span><span
                              class="enlighter-n1">4</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span
                              class="enlighter-m3">addElement</span><span class="enlighter-g1">(</span><span
                              class="enlighter-n1">1</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span
                              class="enlighter-m3">addElement</span><span class="enlighter-g1">(</span><span
                              class="enlighter-n1">8</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span
                              class="enlighter-m3">addElement</span><span class="enlighter-g1">(</span><span
                              class="enlighter-n1">2</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span></div>
            </div>
            <div class="">
                  <div><span class="plain"> System.</span><span class="enlighter-m3">out</span><span
                              class="plain">.</span><span class="enlighter-m3">println</span><span
                              class="enlighter-g1">(</span><span class="enlighter-s0">" ==== original stack
                              iteration before sort === "</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> Iterator</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> it = stack.</span><span
                              class="enlighter-m3">iterator</span><span class="enlighter-g1">()</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">while</span><span
                              class="enlighter-g1">(</span><span class="plain">it.</span><span
                              class="enlighter-m3">hasNext</span><span class="enlighter-g1">())</span><span
                              class="plain"> </span><span class="enlighter-g1">&#123;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> System.</span><span class="enlighter-m3">out</span><span
                              class="plain">.</span><span class="enlighter-m3">println</span><span
                              class="enlighter-g1">(</span><span class="plain">it.</span><span
                              class="enlighter-m3">next</span><span class="enlighter-g1">())</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment"> // call method for sorting
                              of originalStack</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> sortedStack = </span><span
                              class="enlighter-m0">sortStack</span><span class="enlighter-g1">(</span><span
                              class="plain">stack</span><span class="enlighter-g1">)</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span></div>
            </div>
            <div class="">
                  <div><span class="plain"> System.</span><span class="enlighter-m3">out</span><span
                              class="plain">.</span><span class="enlighter-m3">println</span><span
                              class="enlighter-g1">(</span><span class="enlighter-s0">"sortedStack iteration:
                              "</span><span class="enlighter-g1">)</span><span class="plain">;</span>
                  </div>
            </div>
            <div class="">
                  <div><span class="plain"> it = sortedStack.</span><span
                              class="enlighter-m3">iterator</span><span class="enlighter-g1">()</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">while</span><span
                              class="enlighter-g1">(</span><span class="plain">it.</span><span
                              class="enlighter-m3">hasNext</span><span class="enlighter-g1">())</span><span
                              class="plain"> </span><span class="enlighter-g1">&#123;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> System.</span><span class="enlighter-m3">out</span><span
                              class="plain">.</span><span class="enlighter-m3">println</span><span
                              class="enlighter-g1">(</span><span class="plain">it.</span><span
                              class="enlighter-m3">next</span><span class="enlighter-g1">())</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment">/**</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * Java program to sort stack in ascending order.</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * </span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * @param stack</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> * @return</span></div>
            </div>
            <div class="">
                  <div><span class="comment"> */</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">public</span><span
                              class="plain"> </span><span class="keywords">static</span><span
                              class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> </span><span class="enlighter-m0">sortStack</span><span
                              class="enlighter-g1">(</span><span class="plain">Stack</span><span
                              class="enlighter-g1">&lt;</span><span class="plain">integer</span><span
                              class="enlighter-g1">&gt;</span><span class="plain"> stack</span><span
                              class="enlighter-g1">)</span><span class="plain"> </span><span
                              class="enlighter-g1">&#123;</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> newStack = </span><span class="enlighter-k3">new</span><span
                              class="plain"> Stack</span><span class="enlighter-g1">&lt;</span><span
                              class="plain">integer</span><span class="enlighter-g1">&gt;()</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment"> // iterate over till
                              filled stack is not empty </span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">while</span><span
                              class="plain"> </span><span class="enlighter-g1">(</span><span
                              class="plain">!stack.</span><span class="enlighter-m3">isEmpty</span><span
                              class="enlighter-g1">())</span><span class="plain"> </span><span
                              class="enlighter-g1">&#123;</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-k5">int</span><span
                              class="plain"> tmp = stack.</span><span
                              class="enlighter-m3">pop</span><span class="enlighter-g1">()</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment"> // iterate and check if
                              newStack.peek value &gt; tmp, </span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="comment"> // re-push in original
                              stack from popping new stack</span><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">while</span><span
                              class="plain"> </span><span class="enlighter-g1">(</span><span
                              class="plain">!newStack.</span><span
                              class="enlighter-m3">isEmpty</span><span class="enlighter-g1">()</span><span
                              class="plain"> &amp;&amp; newStack.</span><span
                              class="enlighter-m3">peek</span><span class="enlighter-g1">()</span><span
                              class="plain"> </span><span class="enlighter-g1">&gt;</span><span
                              class="plain"> tmp</span><span class="enlighter-g1">)</span><span
                              class="plain"> </span><span class="enlighter-g1">&#123;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> stack.</span><span class="enlighter-m3">push</span><span
                              class="enlighter-g1">(</span><span class="plain">newStack.</span><span
                              class="enlighter-m3">pop</span><span class="enlighter-g1">())</span><span
                              class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> newStack.</span><span class="enlighter-m3">push</span><span
                              class="enlighter-g1">(</span><span class="plain">tmp</span><span
                              class="enlighter-g1">)</span><span class="plain">;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="keywords">return</span><span
                              class="plain"> newStack;</span></div>
            </div>
            <div class="">
                  <div><span class="plain"> </span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span></div>
            </div>
            <div class="">
                  <div><span class="plain"></span><span class="enlighter-g1">&#125;</span><span
                              class="plain"></span></div>
            </div>
            
      </div>
      
      <div class="enlighter-toolbar-bottom enlighter-toolbar"></div>
</div>

<h2>3. Output of stack sorting</h2>
<div class="enlighter-default enlighter-v-standard enlighter-t-atomic enlighter-hover enlighter-linenumbers ">
      
      <div class="output" >
            <div class="">
                  <div><span class="plain">==== original stack iteration before sort === </span></div>
            </div>
            <div class="">
                  <div><span class="plain">9</span></div>
            </div>
            <div class="">
                  <div><span class="plain">4</span></div>
            </div>
            <div class="">
                  <div><span class="plain">1</span></div>
            </div>
            <div class="">
                  <div><span class="plain">8</span></div>
            </div>
            <div class="">
                  <div><span class="plain">2</span></div>
            </div>
            <div class="">
                  <div><span class="plain">sortedStack iteration: </span></div>
            </div>
            <div class="">
                  <div><span class="plain">1</span></div>
            </div>
            <div class="">
                  <div><span class="plain">2</span></div>
            </div>
            <div class="">
                  <div><span class="plain">4</span></div>
            </div>
            <div class="">
                  <div><span class="plain">8</span></div>
            </div>
            <div class="">
                  <div><span class="plain">9</span></div>
            </div>
      </div>
      <div class="enlighter-raw">==== original stack iteration before sort ===
            9 <br />
            4 <br />
            1 <br />
            8 <br />
            2 <br />
            sortedStack iteration: <br />
            1 <br />
            2 <br />
            4 <br />
            8 <br />
            9</div>
      <div class="enlighter-toolbar-bottom enlighter-toolbar"></div>
</div>
 



</div>
        </div>
    )
}

export default Jva_sort
